import { reducer as form } from 'redux-form/immutable';
import { combineReducers } from 'redux-immutable';
import eventsReducer from './events/reducer';
import authReducer from './auth/reducer';
import chartIQReducer from './chart-iq/chart/reducer';
import drawingReducer from './chart-iq/drawing/reducer';
import studyReducer from './chart-iq/study/reducer';
import themeReducer from './chart-iq/theme/reducer';
import chartReducer from './chart/reducer';
import layoutReducer from './layout/reducer';
import newsReducer from './news/reducer';
import socketReducer from './socket/reducer';
import stocksReducer from './stocks/reducer';
import tableReducer from './table/reducer';
import keycloakReducer from './keycloak/reducer';

export default function createReducer() {
	return combineReducers({
    events: eventsReducer,
    auth: authReducer,
    chart: chartReducer,
    chartiq: chartIQReducer,
    drawing: drawingReducer,
    form,
    layout: layoutReducer,
    news: newsReducer,
    socket: socketReducer,
    stocks: stocksReducer,
    study: studyReducer,
    table: tableReducer,
    theme: themeReducer,
    keycloak: keycloakReducer
  });
}
